/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cat_dataviz_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn your data into clean, colourful charts in seconds.`)
};

const es_cat_dataviz_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte tus datos en gráficos claros y coloridos en segundos.`)
};

const de_cat_dataviz_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwandeln Sie Ihre Daten in Sekunden in übersichtliche, farbenfrohe Diagramme.`)
};

const nl_cat_dataviz_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zet je gegevens in seconden om in heldere, kleurrijke grafieken.`)
};

const fr_cat_dataviz_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transformez vos données en graphiques clairs et colorés en quelques secondes.`)
};

const it_cat_dataviz_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasforma i tuoi dati in grafici puliti e colorati in pochi secondi.`)
};

const pt_br2_cat_dataviz_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforme seus dados em gráficos coloridos e organizados em segundos.`)
};

const pt_cat_dataviz_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforme os seus dados em gráficos limpos e coloridos em segundos.`)
};

const ja_cat_dataviz_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データを数秒できれいでカラフルなチャートに変換。`)
};

const zh_cat_dataviz_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`几秒钟内将你的数据变成清晰美观的图表。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cat_dataviz_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cat_dataviz_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cat_dataviz_desc", locale)
	if (locale === "en") return en_cat_dataviz_desc(inputs)
	if (locale === "es") return es_cat_dataviz_desc(inputs)
	if (locale === "de") return de_cat_dataviz_desc(inputs)
	if (locale === "nl") return nl_cat_dataviz_desc(inputs)
	if (locale === "fr") return fr_cat_dataviz_desc(inputs)
	if (locale === "it") return it_cat_dataviz_desc(inputs)
	if (locale === "pt-BR") return pt_br2_cat_dataviz_desc(inputs)
	if (locale === "pt") return pt_cat_dataviz_desc(inputs)
	if (locale === "ja") return ja_cat_dataviz_desc(inputs)
	return zh_cat_dataviz_desc(inputs)
};